import React from "react";
import classnames from "classnames";
import Link from "next/link";
import { ChevronLeftOutlined as ChevronLeft } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronLeftOutlined";
import styles from "./breadcrumb.module.scss";
import { useIsApp } from "../../hooks";

function Breadcrumb({ links, nativeLink = false, className = undefined }) {
  const isApp = useIsApp();
  if (isApp) {
    return <div className={styles.noBorder} />;
  }
  return (
    <ol data-test="breadcrumb" className={classnames(styles.breadcrumb, className)}>
      {links.map(({ href, text, onClick }) => (
        <li key={href} className={styles.breadcrumb__item}>
          {!nativeLink ? (
            <Link href={href} className={styles.breadcrumb__link}>
              <ChevronLeft className={styles.breadcrumb__icon} />
              {text}
            </Link>
          ) : (
            <a className={styles.breadcrumb__link} href={href} onClick={onClick}>
              <ChevronLeft className={styles.breadcrumb__icon} />
              {text}
            </a>
          )}
        </li>
      ))}
    </ol>
  );
}

export default Breadcrumb;
